import { withInstall } from '@jdesign-vue/utils'

import ConfigProvider from './src/config-provider'

export const JdConfigProvider = withInstall(ConfigProvider)
export default JdConfigProvider

export * from './src/config-provider'
export * from './src/config-provider-props'
export * from './src/constants'
export * from './src/hooks/use-global-config'
